// English translations keyed by the Italian source string.
// Missing keys fall back to the Italian text automatically.
export const en = {
    // --- API / errors ---
    "Qualcosa è andato storto. Riprova.": "Something went wrong. Please try again.",
    "Troppi tentativi. Riprova tra qualche minuto.": "Too many attempts. Try again in a few minutes.",
    "Errore del server ({{status}}). Riprova.": "Server error ({{status}}). Please try again.",
    "Impossibile contattare il server. Controlla la connessione e riprova.": "Cannot reach the server. Check your connection and try again.",
    "Accesso riuscito ma la sessione non è stata salvata. Abilita i cookie e riprova.": "Signed in, but the session wasn't saved. Enable cookies and try again.",
    "Registrazione riuscita ma la sessione non è stata salvata. Abilita i cookie e riprova.": "Signed up, but the session wasn't saved. Enable cookies and try again.",

    // --- Backend error details ---
    "Risorsa non trovata": "Resource not found",
    "Non autenticato": "Not authenticated",
    "Tipo di token non valido": "Invalid token type",
    "Utente non trovato": "User not found",
    "Token scaduto": "Token expired",
    "Token non valido": "Invalid token",
    "Accesso non consentito": "Access denied",
    "Ruolo non valido": "Invalid role",
    "Email già registrata": "Email already registered",
    "Troppi tentativi. Riprova tra 15 minuti.": "Too many attempts. Try again in 15 minutes.",
    "Email o password non corretti": "Incorrect email or password",
    "Professionista non trovato": "Professional not found",
    "Completa prima il tuo profilo professionale.": "Complete your professional profile first.",
    "Completa prima il tuo profilo professionale": "Complete your professional profile first",
    "Il tuo profilo è già verificato.": "Your profile is already verified.",
    "Formato immagine non supportato (jpg, png, webp, gif)": "Unsupported image format (jpg, png, webp, gif)",
    "Immagine troppo grande (max 8MB)": "Image too large (max 8MB)",
    "Caricamento non riuscito, riprova": "Upload failed, please try again",
    "File non trovato": "File not found",
    "Richiesta non disponibile": "Request not available",
    "Offerta non trovata": "Offer not found",
    "Non autorizzato": "Not authorized",
    "Prenotazione annullata": "Booking cancelled",
    "Lavoro già completato": "Job already completed",
    "Acconto già versato": "Deposit already paid",
    "Versa prima l'acconto": "Pay the deposit first",
    "Fase di pagamento non valida": "Invalid payment phase",
    "Importo non valido": "Invalid amount",
    "Transazione non trovata": "Transaction not found",
    "Firma non valida": "Invalid signature",
    "Stato non valido": "Invalid status",
    "Prenotazione non trovata": "Booking not found",
    "Puoi recensire solo lavori completati": "You can only review completed jobs",
    "Hai già recensito questo lavoro": "You have already reviewed this job",
    "Messaggio vuoto": "Empty message",
    "Nessun pagamento da rimborsare per questa prenotazione": "No payment to refund for this booking",

    // --- Shared UI (badges, header, notifications) ---
    "Nessuna recensione": "No reviews",
    "Verificato": "Verified",
    "In attesa": "Pending",
    "Confermato": "Confirmed",
    "In corso": "In progress",
    "Completato": "Completed",
    "Annullato": "Cancelled",
    "Aperta": "Open",
    "Assegnata": "Assigned",
    "Da pagare": "To pay",
    "Acconto versato": "Deposit paid",
    "Pagato": "Paid",
    "In garanzia": "In escrow",
    "Non riuscito": "Failed",
    "Rimborsato": "Refunded",
    "Notifiche attivate!": "Notifications enabled!",
    "Permesso negato dal browser.": "Permission denied by the browser.",
    "Impossibile attivare le notifiche su questo dispositivo.": "Couldn't enable notifications on this device.",
    "Notifiche disattivate": "Notifications disabled",
    "Notifiche bloccate": "Notifications blocked",
    "Le notifiche sono bloccate: riattivale dalle impostazioni del browser per questo sito.": "Notifications are blocked: re-enable them in your browser settings for this site.",
    "Notifiche attive": "Notifications on",
    "Disattiva notifiche": "Disable notifications",
    "Attiva notifiche": "Enable notifications",
    "Home": "Home",
    "Cerca": "Search",
    "Accedi": "Sign in",
    "Dashboard": "Dashboard",
    "Messaggi": "Messages",
    "Trova un professionista": "Find a professional",
    "Come funziona": "How it works",
    "Categorie": "Categories",
    "La mia dashboard": "My dashboard",
    "Esci": "Log out",
    "Registrati": "Sign up",
    "Apri menu": "Open menu",

    // --- Landing ---
    "Professionisti verificati vicino a te": "Verified professionals near you",
    "Pubblica una richiesta e ricevi proposte da professionisti verificati nella tua zona.": "Post a request and get offers from verified professionals in your area.",
    "Di cosa hai bisogno? (es. idraulico)": "What do you need? (e.g. plumber)",
    "+1.200 professionisti": "+1,200 professionals",
    "4.9 media recensioni": "4.9 average rating",
    "Identità verificata": "Verified identity",
    "Documenti e competenze controllati dal nostro team.": "Documents and skills checked by our team.",
    "Recensioni autentiche": "Genuine reviews",
    "Solo da clienti che hanno completato un lavoro.": "Only from clients who completed a job.",
    "Pagamenti sicuri": "Secure payments",
    "Trattenuti in garanzia fino al termine del servizio.": "Held in escrow until the service is completed.",
    "Dalla richiesta al lavoro finito, in fiducia": "From request to finished job, with trust",
    "Cerca o pubblica": "Search or post",
    "Sfoglia i professionisti verificati oppure pubblica la tua richiesta e ricevi offerte.": "Browse verified professionals or post your request and get offers.",
    "Scegli con fiducia": "Choose with confidence",
    "Confronta profili, recensioni e prezzi. Prenota il professionista giusto per te.": "Compare profiles, reviews and prices. Book the right professional for you.",
    "Paga a lavoro fatto": "Pay when the job is done",
    "Il pagamento resta protetto e viene rilasciato solo quando sei soddisfatto.": "Your payment stays protected and is released only when you're satisfied.",
    "Ogni competenza, un professionista": "Every skill, a professional",
    "Vedi tutti": "See all",
    "Da telefono": "On mobile",
    "Ciapum in tasca, ovunque": "Ciapum in your pocket, everywhere",
    "Inquadra il codice QR con la fotocamera del telefono per aprire Ciapum sullo smartphone. Gestisci richieste, offerte e messaggi ovunque ti trovi.": "Scan the QR code with your phone camera to open Ciapum on your smartphone. Manage requests, offers and messages wherever you are.",
    "Ottimizzato per l'uso da cellulare": "Optimized for mobile use",
    "Notifiche push per nuove richieste e messaggi": "Push notifications for new requests and messages",
    "Su iPhone: apri in Safari → Condividi → “Aggiungi a Home” per attivare le notifiche.": "On iPhone: open in Safari → Share → “Add to Home Screen” to enable notifications.",
    "Sei un professionista?": "Are you a professional?",
    "Ricevi richieste dai clienti della tua zona, costruisci la tua reputazione e vieni pagato in sicurezza.": "Get requests from clients in your area, build your reputation and get paid securely.",
    "Inizia a lavorare con Ciapum": "Start working with Ciapum",
    "Il professionista giusto, di cui fidarti.": "The right professional, one you can trust.",

    // --- Auth ---
    "Inserisci il tuo nome.": "Enter your name.",
    "Inserisci un indirizzo email valido.": "Enter a valid email address.",
    "La password deve contenere almeno 6 caratteri.": "Password must be at least 6 characters.",
    "Benvenuto su Ciapum!": "Welcome to Ciapum!",
    "Bentornato!": "Welcome back!",
    "La fiducia è il nostro": "Trust is our",
    "mestiere.": "craft.",
    "Professionisti verificati": "Verified professionals",
    "Identità e competenze controllate.": "Identity and skills verified.",
    "Recensioni reali": "Real reviews",
    "Solo da lavori realmente completati.": "Only from truly completed jobs.",
    "Pagamenti protetti": "Protected payments",
    "In garanzia fino a lavoro finito.": "Held in escrow until the job is done.",
    "Crea il tuo account": "Create your account",
    "Bentornato": "Welcome back",
    "Unisciti a Ciapum in pochi secondi.": "Join Ciapum in seconds.",
    "Accedi per continuare.": "Sign in to continue.",
    "Sono un cliente": "I'm a client",
    "Cerco un servizio": "Looking for a service",
    "Sono un pro": "I'm a pro",
    "Offro un servizio": "I offer a service",
    "Nome completo": "Full name",
    "Almeno 6 caratteri.": "At least 6 characters.",
    "Città": "City",
    "Telefono": "Phone",
    "Attendi…": "Please wait…",
    "Hai già un account?": "Already have an account?",
    "Non hai un account?": "Don't have an account?",
    "← Torna alla home": "← Back to home",

    // --- Browse ---
    "{{count}} professionisti disponibili": "{{count}} professionals available",
    "Lista": "List",
    "Mappa": "Map",
    "Cerca per nome o competenza": "Search by name or skill",
    "Filtra": "Filter",
    "Vicino a te": "Near you",
    "Vicino a me": "Near me",
    "Geolocalizzazione non supportata dal browser": "Geolocation not supported by the browser",
    "Professionisti ordinati per vicinanza a te": "Professionals sorted by distance from you",
    "Impossibile ottenere la tua posizione": "Couldn't get your location",
    "Raggio:": "Radius:",
    "Tutti": "All",
    "Rimuovi vicinanza": "Remove proximity",
    "Tutte le categorie": "All categories",
    "Alcuni professionisti non hanno una posizione sulla mappa e non sono mostrati.": "Some professionals don't have a map location and aren't shown.",
    "Nessun professionista trovato con questi filtri.": "No professionals found with these filters.",
    "a meno di 1 km da te": "less than 1 km from you",
    "a {{km}} km da te": "{{km}} km from you",

    // --- Professional profile / booking ---
    "Solo i clienti possono prenotare": "Only clients can book",
    "Richiesta di prenotazione inviata!": "Booking request sent!",
    "Competenze": "Skills",
    "Lavori svolti": "Completed work",
    "Lavoro": "Job",
    "Recensioni": "Reviews",
    "Ancora nessuna recensione.": "No reviews yet.",
    "Cliente": "Client",
    "Tariffa oraria": "Hourly rate",
    "/ora": "/hour",
    "ora": "hour",
    "(stima)": "(est.)",
    "anni di esperienza": "years of experience",
    "Si sposta fino a {{km}} km da {{city}}": "Travels up to {{km}} km from {{city}}",
    "Prenota ora": "Book now",
    "Prenota {{name}}": "Book {{name}}",
    "Descrivi il lavoro": "Describe the job",
    "Es. Riparazione perdita sotto il lavello…": "E.g. Fix a leak under the sink…",
    "Budget ({{sym}})": "Budget ({{sym}})",
    "Data": "Date",
    "Invio…": "Sending…",
    "Invia richiesta": "Send request",
    "Contatta": "Contact",
    "Il pagamento viene trattenuto in garanzia e rilasciato solo a lavoro completato.": "Payment is held in escrow and released only when the job is completed.",
    // --- Chat ---
    "Nessuna conversazione ancora.": "No conversations yet.",
    "Avvia la conversazione": "Start the conversation",
    "Scrivi il primo messaggio 👋": "Write the first message 👋",
    "Scrivi un messaggio…": "Write a message…",
    // --- Map ---
    "Nuovo": "New",
    "Vedi profilo": "View profile",

    // --- Client dashboard ---
    "Ciao, {{name}}": "Hi, {{name}}",
    "Gestisci le tue prenotazioni e richieste.": "Manage your bookings and requests.",
    "Prenotazioni": "Bookings",
    "Le mie richieste": "My requests",
    "Nessuna prenotazione. Trova un professionista per iniziare.": "No bookings. Find a professional to get started.",
    "Acconto {{pct}}%: {{deposit}} · Saldo: {{balance}}": "Deposit {{pct}}%: {{deposit}} · Balance: {{balance}}",
    "Paga acconto": "Pay deposit",
    "Paga saldo": "Pay balance",
    "Recensito": "Reviewed",
    "Nessuna richiesta pubblicata. Pubblicane una e ricevi offerte!": "No requests posted. Post one and get offers!",
    "{{count}} offerte": "{{count}} offers",
    "Accetta": "Accept",
    "Ancora nessuna offerta.": "No offers yet.",
    "Offerta accettata! Prenotazione creata.": "Offer accepted! Booking created.",
    "Geolocalizzazione non supportata": "Geolocation not supported",
    "Posizione acquisita": "Location acquired",
    "Impossibile ottenere la posizione": "Couldn't get your location",
    "Richiesta pubblicata!": "Request posted!",
    "Pubblica una richiesta": "Post a request",
    "Nuova richiesta": "New request",
    "Titolo": "Title",
    "Es. Tinteggiare soggiorno 20mq": "E.g. Paint a 20 sqm living room",
    "Descrizione": "Description",
    "Categoria": "Category",
    "Scegli": "Choose",
    "Budget indicativo (€)": "Estimated budget (€)",
    "Posizione precisa acquisita": "Precise location acquired",
    "Aiuta a trovare artigiani vicini": "Helps find nearby professionals",
    "Aggiorna": "Update",
    "Usa la mia posizione": "Use my location",
    "Pubblico…": "Posting…",
    "Pubblica richiesta": "Post request",
    "Grazie per la recensione!": "Thanks for your review!",
    "Lascia recensione": "Leave a review",
    "Recensisci {{name}}": "Review {{name}}",
    "Com'è andata?": "How did it go?",
    "Invia recensione": "Submit review",

    // --- Pro dashboard ---
    "Foto caricata": "Photo uploaded",
    "{{count}} immagine/i aggiunta/e": "{{count}} image(s) added",
    "Profilo aggiornato!": "Profile updated!",
    "Stato aggiornato": "Status updated",
    "Documento inviato! Verificheremo la tua identità a breve.": "Document submitted! We'll verify your identity shortly.",
    "Offerta inviata!": "Offer sent!",
    "Dashboard professionista": "Professional dashboard",
    "Gestisci lavori, offerte e profilo.": "Manage jobs, offers and profile.",
    "Completa il profilo per iniziare a ricevere richieste.": "Complete your profile to start receiving requests.",
    "Non hai ancora un profilo pubblico. Compilalo nella scheda": "You don't have a public profile yet. Fill it in the",
    "Lavori": "Jobs",
    "Incassi": "Earnings",
    "Richieste aperte": "Open requests",
    "Profilo": "Profile",
    "Nessun lavoro ancora. Fai offerte sulle richieste aperte!": "No jobs yet. Make offers on open requests!",
    "Cliente: {{name}}": "Client: {{name}}",
    "Netto (dopo {{pct}}%)": "Net (after {{pct}}%)",
    "Inizia lavoro": "Start job",
    "Segna completato": "Mark completed",
    "In attesa del pagamento del cliente…": "Waiting for the client's payment…",
    "Incassato (lordo)": "Received (gross)",
    "Commissione ({{pct}}%)": "Commission ({{pct}}%)",
    "Netto per te": "Net for you",
    "Ancora nessun incasso. Qui vedrai acconti e saldi ricevuti dai tuoi lavori.": "No earnings yet. You'll see deposits and balances received from your jobs here.",
    "Prenotazione": "Booking",
    "Acconto": "Deposit",
    "Saldo": "Balance",
    "Nessuna richiesta aperta al momento.": "No open requests at the moment.",
    "Fuori dalla tua zona": "Outside your area",
    "Cliente: {{name}} · {{count}} offerte": "Client: {{name}} · {{count}} offers",
    "Anni di esperienza": "Years of experience",
    "Paese (valuta)": "Country (currency)",
    "🇮🇹 Italia (€ EUR)": "🇮🇹 Italy (€ EUR)",
    "🇨🇭 Svizzera (CHF)": "🇨🇭 Switzerland (CHF)",
    "🇫🇷 Francia (€ EUR)": "🇫🇷 France (€ EUR)",
    "🇩🇪 Germania (€ EUR)": "🇩🇪 Germany (€ EUR)",
    "🇪🇸 Spagna (€ EUR)": "🇪🇸 Spain (€ EUR)",
    "🇬🇧 Regno Unito (£ GBP)": "🇬🇧 United Kingdom (£ GBP)",
    "🇺🇸 Stati Uniti ($ USD)": "🇺🇸 United States ($ USD)",
    "Zona di lavoro — raggio (km)": "Service area — radius (km)",
    "Es. 30": "E.g. 30",
    "Foto profilo": "Profile photo",
    "Caricamento…": "Uploading…",
    "Carica foto": "Upload photo",
    "Portfolio lavori": "Work portfolio",
    "Aggiungi": "Add",
    "Presentazione": "Introduction",
    "Competenze (separate da virgola)": "Skills (comma separated)",
    "Riparazioni, Emergenze 24h…": "Repairs, 24h emergencies…",
    "Salva modifiche": "Save changes",
    "Crea profilo": "Create profile",
    "Documento in revisione": "Document under review",
    "Verifica rifiutata": "Verification rejected",
    "Non verificato": "Not verified",
    "Identità verificata": "Identity verified",
    "Il badge “Verificato” è attivo sul tuo profilo pubblico.": "The “Verified” badge is active on your public profile.",
    "Abbiamo ricevuto il tuo documento. Ti avviseremo appena la verifica sarà completata.": "We've received your document. We'll notify you as soon as verification is complete.",
    "Verifica la tua identità": "Verify your identity",
    "Carica un documento d’identità (carta d’identità, patente o passaporto) per ottenere il badge": "Upload an identity document (ID card, driver's license or passport) to get the",
    "e ricevere più richieste.": "badge and receive more requests.",
    "documento non valido. Ricarica un documento leggibile.": "invalid document. Please upload a legible document.",
    "Ricarica documento": "Re-upload document",
    "Carica documento": "Upload document",
    "Il documento è visibile solo al nostro team di verifica.": "The document is only visible to our verification team.",
    "Fai offerta": "Make an offer",
    "Offerta per: {{title}}": "Offer for: {{title}}",
    "Il tuo prezzo ({{sym}})": "Your price ({{sym}})",
    "Messaggio": "Message",
    "Presentati e spiega come puoi aiutare…": "Introduce yourself and explain how you can help…",
    "Invia offerta": "Send offer",

    // --- Admin dashboard ---
    "Professionista verificato": "Professional verified",
    "Verifica rimossa": "Verification removed",
    "Rimborso effettuato ({{amount}})": "Refund completed ({{amount}})",
    "Verifica approvata": "Verification approved",
    "Rimborsare al cliente l'intero importo pagato e annullare la prenotazione?": "Refund the full paid amount to the client and cancel the booking?",
    "Pannello amministrazione": "Admin panel",
    "Gestisci la piattaforma Ciapum.": "Manage the Ciapum platform.",
    "Utenti totali": "Total users",
    "Professionisti": "Professionals",
    "Verificati": "Verified",
    "In verifica": "Pending verification",
    "Verifiche": "Verifications",
    "Utenti": "Users",
    "Nome": "Name",
    "Professionista": "Professional",
    "Valutazione": "Rating",
    "Nessuna richiesta di verifica in sospeso.": "No pending verification requests.",
    "Documento d'identità": "Identity document",
    "Apri": "Open",
    "Approva": "Approve",
    "Rifiuta": "Reject",
    "Ruolo": "Role",
    "Prezzo": "Price",
    "Stato": "Status",
    "Pagamento": "Payment",
    "Azioni": "Actions",
    "Rimborsa": "Refund",
    "Rifiuta verifica": "Reject verification",
    "Motivo (mostrato al professionista)": "Reason (shown to the professional)",
    "Es. Documento non leggibile o scaduto.": "E.g. Document illegible or expired.",
    "Conferma rifiuto": "Confirm rejection",

    // === more sections appended below ===
};
